const DAY_MS = 24 * 60 * 60 * 1000;

export const MOCK_LOTS = [
  {
    id: "lot-front",
    name: "Hotel valet bays",
    type: "ONSITE",
    capacity: 26,
  },
  {
    id: "lot-basement",
    name: "Basement B2",
    type: "ONSITE",
    capacity: 12,
  },
  {
    id: "lot-central-market",
    name: "Central Market Car Park",
    type: "OFFSITE",
    capacity: 40,
  },
];

const MOCK_SCHEDULE = [
  { arrivals: 6, departures: 4, vip: 1 },
  { arrivals: 8, departures: 5, vip: 2 },
  { arrivals: 3, departures: 6, vip: 0 },
];

const MOCK_CAPACITY = {
  pickups: [1, 2, 3, 5, 7, 9, 12, 8, 6, 10, 4, 2, 1, 0, 0, 0],
  parking: [0, 1, 3, 6, 9, 11, 7, 5, 8, 12, 10, 6, 4, 2, 1, 0],
};

const pad = (value) => String(value).padStart(2, "0");

export function localDay(value = Date.now()) {
  const date = new Date(value);

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function parseDay(day) {
  const [year, month, date] = day.split("-").map(Number);

  return new Date(year, month - 1, date);
}

export function shiftDay(day, amount) {
  const date = parseDay(day);
  date.setDate(date.getDate() + amount);

  return localDay(date);
}

export function dayDifference(day, now = Date.now()) {
  const current = parseDay(localDay(now));
  const selected = parseDay(day);

  return Math.round((selected.getTime() - current.getTime()) / DAY_MS);
}

export function dayLabel(day, now = Date.now()) {
  const difference = dayDifference(day, now);

  if (difference === 0) return "Today";
  if (difference === 1) return "Tomorrow";

  return parseDay(day).toLocaleDateString(undefined, {
    weekday: "short",
    day: "numeric",
    month: "short",
  });
}

export function mockScheduleFor(day, now = Date.now()) {
  const difference = dayDifference(day, now);

  if (difference >= 0 && difference < MOCK_SCHEDULE.length) {
    return MOCK_SCHEDULE[difference];
  }

  const date = parseDay(day).getDate();

  return {
    arrivals: (date * 3) % 9,
    departures: (date * 5) % 8,
    vip: date % 4 === 0 ? 1 : 0,
  };
}

export function mockCapacityRows({ day, kind, now = Date.now() }) {
  const difference = Math.max(0, dayDifference(day, now));
  const source = MOCK_CAPACITY[kind];

  return Array.from({ length: 24 }, (_, hour) => {
    // Preserve the preview activity that previously covered 06:00–22:00;
    // the newly visible overnight hours start empty.
    const baseUsed = source[hour - 6] ?? 0;
    const used = Math.max(0, Math.min(12, baseUsed + (difference % 3) - 1));
    const nextHour = (hour + 1) % 24;

    return {
      key: `${pad(hour)}:00 – ${pad(nextHour)}:00`,
      startMinute: hour * 60,
      used,
      max: 12,
      perSlotMax: 3,
      blackout: false,
      overridden: false,
    };
  });
}

export function monthGrid(month, now = Date.now(), currentDay = localDay(now)) {
  const [year, monthNumber] = month.split("-").map(Number);
  const first = new Date(year, monthNumber - 1, 1);
  const last = new Date(year, monthNumber, 0);
  const leading = (first.getDay() + 6) % 7;
  const today = currentDay;
  const days = Array.from({ length: last.getDate() }, (_, index) => {
    const day = `${year}-${pad(monthNumber)}-${pad(index + 1)}`;
    const schedule = mockScheduleFor(day, now);

    return {
      day,
      number: index + 1,
      today: day === today,
      past: day < today,
      ...schedule,
    };
  });

  return {
    leading,
    days,
    label: first.toLocaleDateString(undefined, {
      month: "long",
      year: "numeric",
    }),
  };
}

export function monthOf(day) {
  return day.slice(0, 7);
}

export function shiftMonth(month, amount) {
  const [year, monthNumber] = month.split("-").map(Number);
  const date = new Date(year, monthNumber - 1 + amount, 1);

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}`;
}

export function carBelongsToLot(car, lot) {
  if (!car || !lot) return false;

  return (
    car.lotId === lot.id ||
    car.parkedLotName === lot.name ||
    (!car.parkedLotName && car.lotName === lot.name)
  );
}
